<template>
    <div>
        <div id="create-campaign">
            <div class="app-container mb-5" v-if="!$global.loading">

                <div class="page-title mb-3">
                    <router-link to="/campaigns">
                        <span class="breadcrumb-link">
                            <v-icon class="breadcrumb-link-icon">dashboard</v-icon> Mes campagnes
                        </span>
                    </router-link>
                    <v-icon>keyboard_arrow_right</v-icon>
                    <span class="breadcrumb-item">
                        {{ cadh.name }}
                    </span>
                </div>

                <v-stepper @change="setCurrentStep" :value="currentStep" non-linear>
                    <v-stepper-header>

                        <v-stepper-step editable step="1">
                            Contenu de l'e-mail
                        </v-stepper-step>

                        <v-stepper-step editable step="2">
                            Formulaire
                        </v-stepper-step>

                        <v-stepper-step editable step="3">
                            Options d'envoi
                        </v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <email-read-only v-if="cadh.lastForm" :webForm="cadh.lastForm"></email-read-only>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <configuration-choice :readOnly="true"></configuration-choice>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <finalize :readOnly="true" :criterias="criterias"></finalize>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>

            </div>
        </div>
    </div>
</template>
<script>

import { mapMutations, mapState } from "vuex"
import Finalize from "./stepers/Finalize"
import EmailReadOnly from "../cmaj/stepers/EmailReadOnly.vue"
import ConfigurationChoice from "./stepers/ConfigurationChoice.vue"

export default {
    name: "CadhConfig",
    components: { Finalize, EmailReadOnly, ConfigurationChoice },
    data() {
        return {
            loading: false,
            cadh: {},
            criterias: [],
            cadhId: null,
        }
    },
    methods: {
        ...mapMutations("createCadh", ["setCurrentStep", "setFirstPartMail", "setLastPartMail", "setSender", "resetState"
            , "setNoEmail", "setSingleEmail", "setSelectedCriterias", "setCadhConfigId"]),
        getCadhConfig() {
            this.$global.loading = true

            this.$http.get("auth/account/apidae-criterias").then(res => {
                this.criterias = res.body.data.criterias

                this.$http.get("auth/campaigns/cadh/config/" + this.cadhId).then(res => {
                    this.cadh = res.body.data.cadh
                    this.setNoEmail(this.cadh.no_email)
                    this.setSingleEmail(this.cadh.single_email)
                    this.setCadhConfigId(this.cadh.configuration_id)

                    if (this.cadh.apidae_criterias) {
                        let selectedCriterias = []
                        this.cadh.apidae_criterias.forEach(criteria => {
                            let selectedCriteria = this.criterias.find(element => element.id === criteria.external_id)
                            selectedCriterias.push(selectedCriteria.id)
                        })

                        this.setSelectedCriterias(selectedCriterias)
                    }
                })
            })

            this.$global.loading = false
        },
    },
    computed: {
        ...mapState("createCadh", ["currentStep"]),
    },
    created() {
        let hash = this.$route.params.hash
        this.cadhId = parseInt(atob(hash))

        this.setCurrentStep("1")
        this.getCadhConfig()
    },
}
</script>